var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar flex-shrink-0 rounded-full overflow-hidden",class:_vm.borderClass,style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })},[_c('img',{staticClass:"w-full h-full object-cover",attrs:{"src":_vm.src,"alt":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }